import listdata from "./listdata";
import detaildata from "./detaildata";
import formpost from "./formpost";
import emplistdata from "./emplistdata";
import empdetaildata from "./empdetaildata";
import empformpost from "./empformpost";

import { combineReducers } from "redux";

const rootReducer = combineReducers({
  listdata: listdata,
  detaildata: detaildata,
  formpost: formpost,
  emplistdata: emplistdata,
  empdetaildata: empdetaildata,
  empformpost: empformpost,
});

export default rootReducer;
